// pages/About.js
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';

export default function About() {
  return (
    <div className="container">
      <Breadcrumbs
        items={[
          { to: '/tractates', label: 'מסכתות' },
          { label: 'אודות' },
        ]}
      />

      <div className="toolbar toolbar--center">
        <h2 style={{ marginInlineStart: 0 }}>אודות המערכת</h2>
      </div>

      <p className="center" style={{ marginTop: '.5rem' }}>
        <Link to="/tractates">חזרה למסכתות</Link>
      </p>

      <div className="stack-3" style={{ marginTop: '1.25rem' }} dir="rtl">
        {/* א. מטרת האתר */}
        <section>
          <h3 style={{ margin: 0 }}>א. מטרת האתר</h3>
          <p style={{ marginTop: '.5rem' }}>
            פתיחת שערים להוראת הגמרא והכנסת התלמידים לעולם התלמוד. הפדגוגיה באתר
            מבוססת על הוראה שיטתית ע&quot;פ ששת ההישגים בהוראת גמרא, בדגש על פיתוח
            הלומד העצמאי וחיבור התלמיד ללב הסוגיא (הן הרוחני והן העיוני).
          </p>
        </section>

        {/* ב. מה יש באתר */}
        <section>
          <h3 style={{ margin: 0 }}>ב. מה יש באתר</h3>
          <ol style={{ marginTop: '.5rem' }}>
            <li>
              הכנת הסוגיא: חומרי לימוד והוראה ע&quot;פ מסמך ששת ההישגים של הפיקוח על
              הוראת תושב&quot;ע.
            </li>
            <li>
              כלי הוראה: הצעה לפתיחות לשיעור, דפי עבודה, דף מלווה ללימוד עצמאי (ע&quot;פ
              מבנה ומהלך הסוגיא), סיכום הסוגיא, מצגות.
            </li>
            <li>
              הערכה ומשחוק: מבחנים, שאלות לדוגמה, תמונות, פודקאסטים.
            </li>
            <li>
              התלמוד החזותי: תרשימי הסוגיות, קישור לתוכנת התלמוד החזותי, עיונים.
            </li>
            <li>חומרי העשרה נוספים.</li>
          </ol>
        </section>

        {/* ג. צוות הכותבים */}
        <section>
          <h3 style={{ margin: 0 }}>ג. צוות הכותבים</h3>
          <p style={{ marginTop: '.5rem' }}>
            האתר נכתב בליווי מפמ&quot;ר ומפ&quot;א תושב&quot;ע ותלמוד.
          </p>
          <p>מרכז הצוותים – הרב איתי פדור (מדריך גמרא ארצי)</p>
          <p>מפתח האתר – הרב אפרים שרם (ישיבת אביר יעקב)</p>

          <h4 style={{ marginTop: '1rem' }}>כתיבת סביבה לימודית מסלול תושב&quot;ע:</h4>
          <ul style={{ marginTop: '.5rem' }}>
            <li>הרב אמיתי דור (ימ&quot;ה אלקנה)</li>
            <li>הרב אברהם רוזנברג (יב&quot;ע מטה בנימין)</li>
            <li>הרב אלאסף שובל (אמי&quot;ת אלירז)</li>
            <li>הרב רן רשף (מדריך ארצי פדגוגיה דיגיטלית ומדיה)</li>
            <li>הרב ניסים אדרי (התלמוד החזותי)</li>
          </ul>

          <h4 style={{ marginTop: '1rem' }}>כתיבת סביבה לימודית מסלול תלמוד:</h4>
          <ul style={{ marginTop: '.5rem' }}>
            <li>הרב צפניה קלרמן (ישיבת תורה ומדע)</li>
            <li>הרב ידידיה נויימן (צביה פתח תקוה)</li>
            <li>הרב אפרים גלינסקי (ישיבת נווה שמואל)</li>
            <li>הרב גלעד סיטון (יב&quot;ע בית יהודה)</li>
            <li>הרב אשרי רבינוביץ (ישיבת נועם)</li>
            <li>הרב רועי קורצמן (ישיבת נועם)</li>
            <li>הרב מתנאל פרנקל (יב&quot;ע מטה בנימין)</li>
            <li>הרב נחום נתנאל קינן (יב&quot;ע עלי)</li>
            <li>הרב עופר טוייבר (ישיבת חורב)</li>
            <li>הרב גבי שנקולובסקי (ישיבת אוהל שלמה)</li>
            <li>הרב מתן סבג (ישיבת פרחי אהרון)</li>
            <li>הרב מרדכי שלזינגר (יב&quot;ע מטה בנימין)</li>
            <li>הרב אליאב ויזל (ישיבת דרכי נועם)</li>
            <li>הרב יאיר פרויילך (ישיבת הדרום)</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
